import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {

  transform(value: any, toBeSearched: any): any {
    console.log(".......................", value)
    if (!value)
      return null;

    if (!toBeSearched)
      return value;



    if (value[0].driveName) {
      return value.filter(data =>
        data.driveName.toLowerCase().indexOf(toBeSearched.toLowerCase()) !== -1)
    }

    if (value[0].campaignName) {
      return value.filter(data =>
        data.campaignName.toLowerCase().indexOf(toBeSearched.toLowerCase()) !== -1)
    }

    if (value[0].institution) {
      // console.log("value at pipe: ",value);
      return value.filter(data =>
        data.institution.institutionName.toLowerCase().indexOf(toBeSearched.toLowerCase()) !== -1)
    }
    if (value[0].question && value[0].program) {
      console.log(value[1].question)
      return value.filter(data =>
        data.question.toLowerCase().indexOf(toBeSearched.toLowerCase()) !== -1 ||
        data.program &&
        data.program.toLowerCase().indexOf(toBeSearched.toLowerCase()) !== -1)
    }

  }

}
